import React from 'react';
import NoTickets from '../../assets/images/keno/no-tickets.svg';
import { TranslationKeys } from '../../core/constants/translationKeys';

function NotTicket({ t }) {
  return (
    <div className='betslip-empty-content'>
      <div className='betslip-empty-content-inner'>
        <img src={NoTickets} alt='tickets' />
        <p className='no-tickets-txt'>{t(TranslationKeys.NoTickets)}</p>
      </div>
    </div>
  );
}
export default NotTicket;
